import {database} from "../config";

export var ACCOUNTS = {
  CORP_INVENTORY: "corp.inventory",
  CORP_INVENTORY_SHIP: "corp.inventory.ship",
  CORP_BUYBACK_PROFIT: "corp.profit.buyback",
  // CORP_SALE_PROFIT: "corp.profit.sale",
  CORP_LIABILITIES_ISK: "corp.liabilities.isk",
  CORP_LIABILITIES_PANDA: "corp.liabilities.panda",

  CORP_ISK_WITHDRAW: "corp.isk.withdraw",
  CORP_ISK_WITHDRAW_COUNTERPARTY: "corp.isk.withdraw.counterparty",
  CORP_ISK_DEPOSIT: "corp.isk.deposit",
  CORP_LOOT_DEPOSIT: "corp.loot.deposit",

  CORP_SHIP_SALE: "corp.ship.sale",
  CORP_FITTING_SALE: "corp.fittings.sale",
  CORP_MATERIAL_SALE: "corp.material.sale",
  CORP_LOOT_SALE: "corp.loot.sale",

  CORP_PAYMENT_ENGINEER: "corp.payment.engineer",
  CORP_PAYMENT_REFINER: "corp.payment.refiner",
  CORP_PAYMENT_LOGISTICS: "corp.payment.logistics",
  CORP_PAYMENT_INVENTORY: "corp.payment.inventory",
  CORP_PAYMENT_BLUEPRINT: "corp.payment.blueprint",
  CORP_PAYMENT_FITTINGS: "corp.payment.fittings",
  CORP_PAYMENT_MISC: "corp.payment.misc",

  CORP_SRP: "corp.srp",

  CORP_COST_BUILD: "corp.cost.build",
  CORP_COST_BLUEPRINT: "corp.cost.blueprint",

  ADJUSTMENT: "adjustment",
};

export function saveAuditLog(
    transaction,
    actorUserInfo,
    targetUserInfo,
    amounts,
    extraData,
) {
  console.log(amounts);
  return transaction.set(database.collection("audit").doc(), {
    actorUserInfo: actorUserInfo,
    targetUserInfo: targetUserInfo,
    amounts: amounts,
    extraData: extraData || {},
    timestamp: Date.now(),
  })
}